import includes from 'lodash/includes';
import values from 'lodash/values';
import {
  EMPTY_OBJECT,
  SET_MODAL,
  SET_MODAL_VISIBLE,
  SET_MODAL_PROPS,
  MODAL_LAYOUT,
} from '../constants';

const DEFAULT_STATE = {
  visible: false,
  modal: undefined,
  props: EMPTY_OBJECT,
};

export default function(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case SET_MODAL:
      return {
        ...state,
        modal: action.payload,
      };
    case SET_MODAL_VISIBLE:
      return {
        ...state,
        visible: action.payload,
      };
    case SET_MODAL_PROPS:
      return {
        ...state,
        props: action.payload || EMPTY_OBJECT,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/modal.js